import React, { useRef } from 'react'
import Girl from "../Images/Girl.png"
import { motion, useInView } from "framer-motion";
const Home1 = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, margin: "" });

  return (
    <div>
      <div className=' w-[100%]'>
        <div className="absolute left-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Bottom Pink Blobs */}
        <div className="absolute left-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Top Green Blobs */}
        <div className="absolute left-[50%] top-[5%] transform -translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[50%] top-[5%] transform translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>

        <section ref={ref} className="flex flex-col items-center text-center py-16 px-4">
          {/* IT Solutions Provider Badge */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
            transition={{ duration: 0.8 }}
            className="relative z-0 font-[Nunito] inline-block h-[67px] w-[285px] bg-[#432DD7] text-white rounded-full text-[20px] font-[500]"
          >
            <p className="mt-5">IT Solutions Provider</p>
            <div className="absolute bottom-[15px] right-0">
              <img src={Girl} alt="Illustration" className="w-12" />
            </div>
          </motion.div>

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 1, delay: 0.3 }}
            style={{ fontFamily: "PT Sans" }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mt-4"
          >
            Empowering Businesses
          </motion.h1>

          {/* Subheading */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="text-6xl text-purple-600 mt-2 font-[Allison]"
          >
            with <span className="font-[400]">Smart IT Solutions</span>
          </motion.p>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 1, delay: 0.9 }}
            className="text-gray-700 font-[Nunito] max-w-2xl mt-4"
          >
            At Godhani Technology, we bring your ideas to life with cutting-edge IT
            solutions that drive innovation and growth.
          </motion.p>
        </section>
      </div></div>
  )
}

export default Home1
